import CardListML from './CardListML';

export default (props) => {
  return <CardListML {...props} />;
};
